/* eslint-disable react/no-danger */
import React, { useState, useEffect } from 'react';
import { Link } from 'gatsby';
import { Parallax, ParallaxProvider } from 'react-scroll-parallax';

function Item({ item, number }) {
  const [img, setImg] = useState(false);

  let outerWidth = null;
  if (typeof window !== 'undefined') {
    outerWidth = window.outerWidth;
  }

  useEffect(() => {
    if (typeof window !== 'undefined') {
      if (window.outerWidth < 1100) {
        setImg(true);
      }
    }
  }, [outerWidth]);

  return (
    <ParallaxProvider>
      <Parallax
        className="pattern-plus"
        y={[10, -10]}
        tagOuter="figure"
        disabled={img}
      >
        <Link to={item.button_url} className="item">
          <div>
            <img src={item.image.source_url} data-src={item.image.source_url} alt="" />
            <h3 dangerouslySetInnerHTML={{ __html: item.title }} />
            <p dangerouslySetInnerHTML={{ __html: item.description }} />
            <div className={`izi-btn izi-btn-large ${number === 0 ? 'izi-btn-blue-450' : null}`}>{item.button_title}</div>
          </div>
        </Link>
      </Parallax>
    </ParallaxProvider>
  );
}

function SectionB(props) {
  const { content } = props;

  return (
    <section className="section-b">
      <div className="concave-shape">
        <div className="concave-shape-inner" />
      </div>

      {content &&
        <div className="container">
          <div className="info text-center">
            <h2 className="section-title" dangerouslySetInnerHTML={{ __html: content.offer_title }} />
          </div>
          <div className={`row ${content.offer_item_page.length === 2 ? 'width-768' : null}`}>
            {content.offer_item_page && content.offer_item_page.map((item, i) => (
              <div className={`col-12 ${content.offer_item_page.length === 2 ? 'col-md-6' : 'col-md-4'}`} key={item.image.source_url}>
                <Item item={item} number={i} />
              </div>
            ))}
          </div>
        </div>}
    </section>
  );
}

export default SectionB;
